import __request__ from "routing/request";
export function cycle(requestOptions) {
  return __request__("POST", "/cluster/deflector/cycle", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function cycleByindexSetId(indexSetId, requestOptions) {
  return __request__("POST", `/cluster/deflector/${indexSetId}/cycle`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
